import React from 'react';

export class Video extends React.Component {
    state = {
        uri: null,
    };

    onError = () => {
        if (this.props.OnEnd) {
            this.props.onEnd()
        }
    }

    onLoad = () => {
        if (this.props.onLoad) {
            this.props.onLoad();
        }
    }

    loadAsync = async ({ uri }) => {
        this.setState({
            uri,
        });
    }

    playAsync = async () => {
        this._video.play();
    }

    render = () => {
        const { onEnd, overrideVideoStyle } = this.props;
        const { uri } = this.state;
        if (!uri) {
            return <></>;
        }

        return (
            <video
                onLoadedData={this.onLoad}
                ref={video => this._video = video}
                controls
                style={{ height: '80vh', marginTop: '50px', ...overrideVideoStyle }}
                controlsList='nodownload'
                onEnded={onEnd}>
                <source src={uri} type="video/mp4" />
                Cannot play video on your device
            </video>
        );
    }
}
